import RightSlider from 'component/hoc/rightSlider/RightSlider';
import React, { useEffect } from 'react';
import RedirectForm from '../../forms/redirect/RedirectForm';
import { FormikProvider, useFormik } from 'formik';
import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import toast from 'react-hot-toast';
import * as Yup from 'yup';
import { redirect } from 'react-router-dom';
import { isEqual } from 'lodash';

const RedirectModal = ({ isOpen, onClose, title, id, isError }) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    initialWorkflowData,
    setIsChanged,
  } = useWorkflowContext();
  const formik = useFormik({
    initialValues: {
      redirectWorkflowId: selectedNode?.redirectNode?.redirectWorkflowId || '',
      workflowName: selectedNode?.redirect?.workflowName || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      redirectWorkflowId: Yup.string().required('Required'),
    }),
    onSubmit: (values, { resetForm }) => {
      const initialNode = initialWorkflowData?.find((node) => node?.id === id);
      if (initialNode) {
        const { redirectWorkflowId } = initialNode?.redirectNode || {};
        const initialMessageObject = redirectWorkflowId;
        const currentValues = formik.values.redirectWorkflowId;
        const changed = !isEqual(currentValues, initialMessageObject);
        setIsChanged((prev) => {
          const alreadyExists = prev?.includes(id);
          if (changed && !alreadyExists) {
            return [...prev, id];
          }
          if (!changed && alreadyExists) {
            return prev?.filter((nodeId) => nodeId !== id);
          }

          return prev;
        });
      }
    },
  });
  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? {
                ...node,
                redirectNode: formik.values,
                is_Error: isError,
              }
            : node
        );
        setWorkflowData((prev) => {
          return {
            ...prev,
            nodes: updatedNodes,
          };
        });
        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );

    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);
  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <RedirectForm />
      </FormikProvider>
    </RightSlider>
  );
};

export default RedirectModal;
